import React, { useState, useEffect, useContext } from 'react'
import {
    Row,
    Form,
    Col,
    Input,
    FormGroup,
    Label,
    CardTitle,
    Dropdown,
    DropdownToggle,
    DropdownMenu,
    Button
} from "reactstrap"

import { GeneralContext } from '../../../../context'
import { withRouter } from 'react-router-dom'
import { withNamespaces } from "react-i18next"

import DataService from '../../../../helpers/DataService'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronDown, faLink, faEllipsisVertical, faArrowLeft } from '@fortawesome/free-solid-svg-icons'
import bottomButton from '../../../../assets/images/bottom-button.png'
import { toastrError } from "../../../../helpers/Toastr"
import { filteredBlockchains } from "../../../../helpers/constants"
import { segmentTrack } from "../../../../helpers/Segment"
import cn from 'classnames';
import Modal from "../../../../components/Global/modals"



const Settings = (props) => {
    const generalContext = useContext(GeneralContext)
    const { setLoading } = generalContext
    const [tokenDescription, setTokenDescription] = useState('')
    const [tokenExternal, setTokenExternal] = useState('')
    const [collectionName, setCollectionName] = useState('')
    const [collectionFamily, setCollectionFamily] = useState('')
    const [tokens, setTokens] = useState('')
    const [collectionSymbol, setCollectionSymbol] = useState('')
    const [blockchainNetwork, setBlockchainNetwork] = useState(1)
    const [launch_date, setLaunchDate] = useState('')
    const [price, setPrice] = useState('')
    const [seller_fee_basis_points, setSellerFeesBasisPoints] = useState('')
    const [status, setStatus] = useState('yellow')
    const [image_id, setImageId] = useState('')
    const [loading, setRedeployloading] = useState(false)

    let [show_neefter_creator, setShowNeefterCreator] = useState(true);

    let [full_subdomain, setFullSubdomain] = useState('');
    const [showTokenMetadata, setShowTokenMetadata] = useState(false)

    const [assets, setAssets] = useState([])
    // const getCollectionsSettings = () => db.collections_settings.toArray();
    // const collections_settings = useLiveQuery(getCollectionsSettings);
    // const getAssetsCount = () => db.assets.count();
    // const assets_count = useLiveQuery(getAssetsCount);
    const [showModal, setShowModal] = useState(false)

    const [collection_saved, setCollectionSaved] = useState('')
    const [collection_setting_saved, setCollectionSettingSaved] = useState('')

    const { project_id, activeForm, collection_id, collection, inputLoader, setInputLoader, setCollectionReload, count_traits } = props;
    const min_creator_arr = [
        {
            address: '',
            share: '',
            error: false,
        }
    ];
    const [creator_array, setCreatorArray] = useState([]);
    const commentErrorLength = 'Only 1000 characters or less can be added for the description field'

    // togle 
    const [menu, setMenu] = useState(false)
    let [selectedBlockChain, setSelectedBlockchain] = useState({
        id: 1,
        name: 'Solana'
    });


    useEffect(() => {
        if (collection) {
            const { brackground, candy_machine_address, csv, description, external_url,
                family, favicon, high_fidelity_icon, id, image_id, is_candy_machine, is_deployed,
                is_deploying, launch_date, logo, name, network_id, organization_id, price, project_id,
                slug, subdomain, symbol, seller_fee_basis_points,
                creators, blockchain, total_tokens
            } = collection;
            const launch = launch_date ? new Date(launch_date) : '';
            if (launch) {
                const year = launch.getFullYear()
                let month = parseInt(launch.getMonth() + 1)
                month = (month + '').length > 1 ? month : '0' + month
                const day = ((launch.getDate() + '').length > 1 ? launch.getDate() : '0' + launch.getDate());
                let date = year + "-" + month + "-" + day;
                setLaunchDate(date)
            }

            setCollectionSettingSaved(id || '')
            setCollectionName(name || '')
            setBlockchainNetwork(network_id || 1)
            setSelectedBlockchain(filteredBlockchains.find(fb => (fb.id + '') === (network_id + '')))
            setCollectionFamily(family || '')
            setTokens((count_traits ? count_traits : total_tokens) || 0)
            setCollectionSymbol(symbol || '')
            setTokenExternal(external_url || '')
            setTokenDescription(description || '')
            setImageId(collection.image_id)

            setPrice(price || '')
            if (network_id === 1) {
                setFullSubdomain(`https://${subdomain}.neefter.com`)
            } else {
                setFullSubdomain(`https://${subdomain}.neefter.net`)
            }

            setSellerFeesBasisPoints(seller_fee_basis_points ? seller_fee_basis_points / 100 : '0')

            console.log('seller_fee_basis_points', seller_fee_basis_points);
            if (!seller_fee_basis_points) {
                setShowNeefterCreator(false)
            }

            if (creators && seller_fee_basis_points) {
                creators.forEach(creator => {
                    setCreatorArray((arr) => {
                        return [
                            ...arr,
                            {
                                address: creator.address,
                                share: creator.share,
                                error: false,
                            }
                        ];
                    });
                });
            }
            if (!is_deployed && !is_deploying) {
                setStatus('red')
            } else if (!is_deployed && is_deploying) {
                setStatus('yellow')
            } if (is_deployed && !is_deploying) {
                setStatus('green')
            }
        }
    }, [collection])


    useEffect(() => {
        if (activeForm > 0) {
            _handleSubmit();
        }
    }, [activeForm])



    const _validateStep = () => {

        if (launch_date === '') {
            toastrError(props.t(`Don't forget to enter the launch date`), 'Error')
            return false
        }
        if (price === '') {
            toastrError(props.t(`Don't forget to enter the price`), 'Error')
            return false
        }
        return true
    }


    const _handleSubmit = async (e) => {
        if (!_validateStep()) return;
        setInputLoader(true)
        setLoading(true)
        try {
            DataService.putCollectionById(collection_id, {
                price: price,
                launch_date: launch_date,
            }).then(response => {
                if (response && response.data) {
                    // props.history.push(`/collections`)
                    setInputLoader(false)
                    setLoading(false)
                }
            })
        } catch (error) {
            toastrError(`Failed to add ${collectionName}: ${error}`, 'Error');
            setInputLoader(false)
            setLoading(false)
        }
    }
    const addCreator = () => {
        if ((!seller_fee_basis_points || seller_fee_basis_points === 0 || seller_fee_basis_points === '0')) return;
        setCreatorArray((arr) => {
            return [
                ...arr,
                {
                    address: '',
                    share: '',
                    error: false,
                }
            ];
        });
    };
    const removeCreatorInput = (index) => {
        setCreatorArray((item) =>
            item.filter((current, _ind) => _ind !== index)
        )
    }
    const handleChangeCreatorAddress = (event) => {
        event.preventDefault();
        const val = 'creator_address';
        const index = event.target.id.slice(val.length);

        const value = event.target.value;
        setCreatorArray(item => {
            const newArr = item.slice();

            newArr[index].address = value;

            if (!value) {
                newArr[index].error = true;
                document.getElementById(val + index).classList.add('input-error')
            } else {
                newArr[index].error = false;
                document.getElementById(val + index).classList.remove('input-error')
            }

            // var regexp = new RegExp(/[`~!@$%^&*()+{}[\]\\|,.//?;':"]/g, 'g');
            // const indexHashtagError = value.match(regexp);
            // const indexSpaceError = value.match(/\s/);
            // if (!value || (indexHashtagError && indexHashtagError?.length > 0) || (indexSpaceError && indexSpaceError?.length > 0)) {
            //     newArr[index].error = true;
            //     document.getElementById(val + index)?.classList.add('mt-required-error')
            // } else {
            //     newArr[index].error = false;
            //     document.getElementById(val + index)?.classList.remove('mt-required-error')
            // }
            return newArr;
        });
    };
    const handleChangeCreatorShare = (event) => {
        event.preventDefault();
        const val = 'creator_share';
        const index = event.target.id.slice(val.length);

        const value = event.target.value;
        setCreatorArray(item => {
            const newArr = item.slice();
            if (!value) {
                newArr[index].error = true;
            } else {
                newArr[index].error = false;
            }
            var regexp = new RegExp(/[`~!@$%^&*()+{}[\]\\|,.//?;':"]/g, 'g');
            const indexHashtagError = value.match(regexp);
            const indexSpaceError = value.match(/\s/);
            if (!value || (indexHashtagError && indexHashtagError?.length > 0) || (indexSpaceError && indexSpaceError?.length > 0)) {
                newArr[index].error = true;
                document.getElementById(val + index).classList.add('input-error')
            } else {
                newArr[index].error = false;
                newArr[index].share = parseFloat(value);
                document.getElementById(val + index).classList.remove('input-error')
            }
            checkAllCreators()
            return newArr;
        });
    };

    function checkAllCreators() {
        let total = 0;
        const checkError = creator_array.find(creator => creator.error)

        if (!checkError) {
            total = creator_array.reduce((acc, creator) => acc + parseFloat(creator.share), 0);

            if (total > 100) {
                const val = 'creator_share';
                const n_array = creator_array.map((creator, index) => {
                    document.getElementById(val + index).classList.add('input-error')
                    return {
                        ...creator,
                        error: true
                    }

                })
                setCreatorArray([...n_array])
                toastrError('The total of shares between all creators cant surpass the 100', 'Error')

            } else {
                const val = 'creator_share';
                const n_array = creator_array.map((creator, index) => {
                    document.getElementById(val + index).classList.remove('input-error')
                    return {
                        ...creator,
                        error: false
                    }
                })
                setCreatorArray([...n_array])
            }
        }
    }

    function naiveRound(num, decimalPlaces = 5) {
        if (!num) return 0;
        var p = Math.pow(10, decimalPlaces);
        return Math.round(num * p) / p;
    }

    const _redeploy = () => {
        setLoading(true)
        setRedeployloading(true)
        DataService.putCollectionRedeploy(collection_id).then(response => {
            console.log('response', response);
            if (response && response.data) {
                setCollectionReload(response.data)
                setLoading(false)
                setRedeployloading(false)
            }
        })

    }

    const modalStyles = {
        content: {
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)',
            width: '80%',
            height: '90%'

        }
    }
    const __renderPOView = (params = null) => (
        <Modal
            className="xxl"
            title={props.t(``)}
            isOpen={showModal}
            onRequestClose={() => {
                setShowModal(false)
            }}
            body={modalBody}
            footer={footer}
            styles={modalStyles}
        />
    )
    const modalBody = <section>
        <div className='deploy-modal'>
            <p className='deploy-modal-title'>Token MetaData</p>
            <section className={cn('container-settings-tab-example dialog')}>
                <div className='container-settings-tab-example-custom dialog'>
                    <div className='container-settings-tab-example-titles'>
                        <span className='container-settings-tab-example-titles token-name'>
                            Token Name
                        </span>
                        <span className='container-settings-tab-example-titles token-media'>
                            Token Media
                        </span>
                        <span className='container-settings-tab-example-titles token-description'>
                            Token <br /> Description
                        </span>
                        <span className='container-settings-tab-example-titles external-url'>
                            External URL
                        </span>
                        <div className='container-settings-tab-example-stroke stoken-name'>
                        </div>
                        <div className='container-settings-tab-example-stroke stoken-media'>
                        </div>
                        <div className='container-settings-tab-example-stroke stoken-description'>
                        </div>
                        <div className='container-settings-tab-example-stroke sexternal-url'>
                        </div>
                    </div>
                    <div className='container-settings-tab-example-card'>
                        <div className='container-settings-tab-example-card-title'>
                            <FontAwesomeIcon icon={faArrowLeft}></FontAwesomeIcon>
                            <span> {collectionName}</span>
                            <FontAwesomeIcon icon={faEllipsisVertical}></FontAwesomeIcon>
                        </div>
                        <div className='container-settings-tab-example-card-img'>
                            <img src={image_id} />
                        </div>
                        <div className='container-settings-tab-example-card-buttons'>
                            <div className='container-settings-tab-example-card-buttons-card'>
                                Send
                            </div>
                            <div className='container-settings-tab-example-card-buttons-card'>
                                List
                            </div>
                        </div>
                        <div className='container-settings-tab-example-card-description'>
                            <span className='container-settings-tab-example-card-description-title'>
                                Description
                            </span>
                            <span>
                                {tokenDescription}
                            </span>
                            <span className='container-settings-tab-example-card-description-url'>
                                {tokenExternal}
                            </span>
                        </div>
                        <div className='container-settings-tab-example-card-bottom'>
                            <img src={bottomButton} />
                        </div>
                    </div>

                </div>
            </section>

        </div>
    </section >
    const footer = <div className='deploy-modal-footer'>

    </div>



    return (
        <React.Fragment>
            {
                showModal && __renderPOView(12)
            }
            <Form id="settings-tab-form" >
                <div className='collections-settings text-align-left'>
                    <section className='container-settings-tab'>
                        <section className='container-settings-tab-form'>
                            <div className='container-settings-tab-form-view'>
                                <CardTitle className='collections-settings-tab-title'>{props.t(`Go live settings`)}</CardTitle>
                                {
                                    status === 'green' && (
                                        <div className='container-settings-tab-form-view-subdomain'>
                                            <a href={full_subdomain} target="_blank">
                                                {full_subdomain}
                                            </a>
                                            <div className='container-settings-tab-form-view-subdomain-ico' onClick={() => navigator.clipboard.writeText(full_subdomain)}>
                                                <FontAwesomeIcon icon={faLink}></FontAwesomeIcon>
                                            </div>

                                        </div>
                                    )
                                }
                                {
                                    status === 'yellow' && (
                                        <div className='container-settings-tab-form-view-subdomain'>
                                            <Button
                                                type="button"
                                                color="secundary"
                                                className="theme-button-secundary desktop"
                                                disabled={true}
                                            >
                                                {props.t(`Redeploy`)}
                                            </Button>

                                        </div>
                                    )
                                }
                                {
                                    status === 'red' && (
                                        <div className='container-settings-tab-form-view-subdomain'>
                                            <Button
                                                type="button"
                                                color="secundary"
                                                className="theme-button-secundary desktop"
                                                disabled={loading}
                                                onClick={(e) => {
                                                    e.preventDefault()
                                                    window.analytics.track(`Redeploy`)
                                                    _redeploy()
                                                }}
                                            >
                                                {props.t(`Redeploy`)}
                                            </Button>

                                        </div>
                                    )
                                }
                            </div>
                            <div className='collections-settings-row'>
                                <div className='collections-settings-item'>
                                    <Row>
                                        <Col sm={6}>
                                            <FormGroup>
                                                <Label className='input-label_monserrat'>
                                                    {props.t(`Go live date`)}
                                                </Label>
                                                <Input
                                                    type="date"
                                                    name="launch_date"
                                                    id="launch_date"
                                                    value={launch_date}
                                                    disabled={inputLoader}
                                                    placeholder="Launch date"
                                                    className="input-white-input circle"
                                                    onChange={event => {
                                                        const { value } = event.target
                                                        if (!value) {
                                                            document.getElementById('launch_date').classList.add('input-error')
                                                        } else {
                                                            document.getElementById('launch_date').classList.remove('input-error')
                                                        }
                                                        setLaunchDate(event.target.value)
                                                    }}
                                                />
                                            </FormGroup>
                                        </Col>
                                        <Col sm={6}>
                                            <FormGroup>
                                                <Label className='input-label_monserrat'>
                                                    {props.t(`Price`)}
                                                </Label>

                                                <Input
                                                    required
                                                    value={price}
                                                    id="price"
                                                    type="text"
                                                    className="input-white-input circle"
                                                    placeholder='Price'
                                                    disabled={inputLoader}
                                                    onChange={event => {
                                                        const { value } = event.target
                                                        if (!value) {
                                                            document.getElementById('price').classList.add('input-error')
                                                        } else {
                                                            document.getElementById('price').classList.remove('input-error')
                                                        }
                                                        setPrice(event.target.value)
                                                    }}
                                                />
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                </div>
                            </div>
                            <CardTitle className='collections-settings-tab-title'>{props.t(`General settings`)}</CardTitle>
                            <div className='collections-settings-row'>

                                <div className='collections-settings-item'>
                                    <Row>
                                        <Col sm={6}>
                                            <FormGroup>
                                                <Label className='input-label_monserrat'>
                                                    {props.t(`Collection name`)}
                                                </Label>

                                                <Input
                                                    required
                                                    value={collectionName}
                                                    type="text"
                                                    className="input-white-input circle"
                                                    placeholder='Collection name'
                                                    id='collectionName'
                                                    disabled
                                                    onChange={event => {
                                                        const { value } = event.target
                                                        if (!value) {
                                                            document.getElementById('collectionName').classList.add('input-error')
                                                        } else {
                                                            document.getElementById('collectionName').classList.remove('input-error')
                                                        }
                                                        setCollectionName(event.target.value)
                                                    }}
                                                />
                                            </FormGroup>
                                        </Col>

                                        <Col sm={6}>
                                            <FormGroup>
                                                <Label className='input-label_monserrat'>
                                                    {props.t(`Collection Family`)}
                                                </Label>

                                                <Input
                                                    required
                                                    value={collectionFamily}
                                                    type="text"
                                                    id='collectionFamily'
                                                    className="input-white-input circle"
                                                    placeholder='Stark'
                                                    disabled
                                                    onChange={event => {
                                                        const { value } = event.target
                                                        if (!value) {
                                                            document.getElementById('collectionFamily').classList.add('input-error')
                                                        } else {
                                                            document.getElementById('collectionFamily').classList.remove('input-error')
                                                        }
                                                        setCollectionFamily(event.target.value)
                                                    }}
                                                />
                                            </FormGroup>
                                        </Col>

                                        <Col sm={6}>
                                            <FormGroup>
                                                <Label className='input-label_monserrat'>
                                                    {props.t(`How many tokens`)}
                                                </Label>

                                                <Input
                                                    required
                                                    value={tokens}
                                                    type="text"
                                                    className="input-white-input circle"
                                                    placeholder='0'
                                                    disabled
                                                />
                                            </FormGroup>
                                        </Col>
                                        <Col sm={6}>
                                            <FormGroup>
                                                <Label className='input-label_monserrat'>
                                                    {props.t(`Collection symbol`)}
                                                </Label>

                                                <Input
                                                    required
                                                    value={collectionSymbol}
                                                    id="collectionSymbol"
                                                    type="text"
                                                    className="input-white-input circle"
                                                    placeholder='CPT'
                                                    disabled
                                                    onChange={event => {
                                                        const { value } = event.target
                                                        if (!value) {
                                                            document.getElementById('collectionSymbol').classList.add('input-error')
                                                        } else {
                                                            document.getElementById('collectionSymbol').classList.remove('input-error')
                                                        }
                                                        setCollectionSymbol(event.target.value)
                                                    }}
                                                />
                                            </FormGroup>
                                        </Col>
                                        <Col sm={6}>
                                            <FormGroup>
                                                <Label className='input-label_monserrat'>
                                                    {props.t(`Blockchain network`)}
                                                </Label>
                                                <Dropdown
                                                    style={{ width: '100%' }}
                                                    isOpen={menu}
                                                    className="d-inline-block"
                                                    disabled
                                                >
                                                    <DropdownToggle
                                                        className="input-drop-white"
                                                        id="select-block-dropdown"
                                                        tag="button"
                                                    >
                                                        <span className="header-item-project-name">
                                                            {selectedBlockChain && (
                                                                <span>{selectedBlockChain.name}</span>
                                                            )}
                                                        </span>
                                                        <FontAwesomeIcon icon={faChevronDown}></FontAwesomeIcon>
                                                    </DropdownToggle>
                                                    <DropdownMenu right className='input-drop-white-item'>
                                                        {filteredBlockchains.map(
                                                            (item, key) => (
                                                                <div key={key} className="dropdown-item " onClick={() => {
                                                                    setSelectedBlockchain(item)
                                                                    setBlockchainNetwork(item.id)
                                                                    setMenu(false)
                                                                }}>
                                                                    <span>{item.name}</span>
                                                                </div>
                                                            ))}
                                                    </DropdownMenu>
                                                </Dropdown>
                                            </FormGroup>
                                        </Col>
                                        <Col sm={6}>
                                            <FormGroup>
                                                <Label className='input-label_monserrat'>
                                                    {props.t(`External URL`)}
                                                </Label>

                                                <Input
                                                    required
                                                    value={tokenExternal}
                                                    id="tokenExternal"
                                                    type="text"
                                                    className="input-white-input circle"
                                                    placeholder='URL or Link'
                                                    disabled
                                                    onChange={event => {
                                                        const { value } = event.target
                                                        if (!value) {
                                                            document.getElementById('tokenExternal').classList.add('input-error')
                                                        } else {
                                                            document.getElementById('tokenExternal').classList.remove('input-error')
                                                        }
                                                        setTokenExternal(event.target.value)
                                                    }}
                                                />
                                            </FormGroup>
                                            <p className='title-mini'>This URL will appear next to the asset’s image.</p>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col sm={6}>
                                            <FormGroup>
                                                <Label className='input-label_monserrat'>
                                                    {props.t(`Token description`)}
                                                </Label>

                                                <Input
                                                    required
                                                    style={{ padding: 10 }}
                                                    type="textarea"
                                                    className="input-white-input circle input-text-area"
                                                    placeholder="The description will be included on the item's detail page underneath 
                                            its image. Markdown syntax is supported."
                                                    value={tokenDescription}
                                                    id="tokenDescription"
                                                    disabled
                                                    onChange={event => {
                                                        const { value } = event.target
                                                        if (!value) {
                                                            document.getElementById('tokenDescription').classList.add('input-error')
                                                        } else {
                                                            if (value.length > 1000) {
                                                                toastrError(commentErrorLength)
                                                                document.getElementById('tokenDescription').classList.add('input-error')
                                                            } else {
                                                                document.getElementById('tokenDescription').classList.remove('input-error')
                                                            }
                                                        }
                                                        setTokenDescription(event.target.value)
                                                    }}
                                                />

                                            </FormGroup>

                                        </Col>
                                    </Row>

                                    <Row>
                                        <Col sm={12}>
                                            <Button
                                                type="button"
                                                color="secundary"
                                                className="theme-button-collaborator mobile"
                                                disabled={inputLoader}
                                                onClick={(e) => {
                                                    e.preventDefault()
                                                    // segmentTrack(`update project`)
                                                    // setShowTokenMetadata(!showTokenMetadata)
                                                    setShowModal(true)
                                                }}
                                            >
                                                {props.t(`${showTokenMetadata ? 'Hide' : 'Show'} token metadata`)}
                                            </Button>
                                        </Col>
                                    </Row>

                                </div>
                            </div>
                            {/* <CardTitle className='collections-settings-tab-title'>{props.t(`Art work settings`)}</CardTitle>
                    <div className='collections-settings-row'>
                        <div className='collections-settings-item'>
                            <Row>
                                <Col sm={6}>
                                    <FormGroup>
                                        <Label className='input-label_monserrat'>
                                            {props.t(`Art work size in pixels`)}
                                        </Label>

                                        <Input
                                            required
                                            value={collectionName}
                                            type="text"
                                            className="input-white-input circle"
                                            placeholder='1024'
                                            onChange={event => setCollectionName(event.target.value)}
                                        />
                                    </FormGroup>
                                </Col>

                            </Row>
                        </div>
                        <div className='collections-settings-item'></div>
                    </div> */}
                            <CardTitle className='collections-settings-tab-title'>{props.t(`Royalties & comissions`)}</CardTitle>
                            <div className='collections-settings-row'>
                                <div className='collections-settings-item'>
                                    <Row>
                                        <Col sm={6}>
                                            <FormGroup>
                                                <Label className='input-label_monserrat'>
                                                    {props.t(`Royalties %`)}
                                                </Label>
                                                {/* <InputGroup>
                                            <Input
                                                required
                                                value={seller_fee_basis_points}
                                                type="text"
                                                className="input-white-input circle"
                                                id='seller_fee_basis_points'
                                                placeholder=''
                                                step="0.01"
                                                pattern="[-+]?[0-9]*[.,]?[0-9]+"
                                                disabled
                                                onChange={event => {
                                                    const { value } = event.target
                                                    
                                                    if (!value) {
                                                        document.getElementById('seller_fee_basis_points').classList.add('input-error')
                                                    } else {
                                                        document.getElementById('seller_fee_basis_points').classList.remove('input-error')
                                                    }
                                                    setSellerFeesBasisPoints(event.target.value)
                                                }}
                                            />
                                            <InputGroupAddon addonType="append">%</InputGroupAddon>
                                        </InputGroup> */}
                                                <Input
                                                    required
                                                    value={seller_fee_basis_points}
                                                    type="text"
                                                    className="input-white-input circle"
                                                    id='seller_fee_basis_points'
                                                    placeholder=''
                                                    step="0.01"
                                                    pattern="[0-9]*"
                                                    onKeyPress={(event) => {
                                                        if (!/[0-9]/.test(event.key)) {
                                                            event.preventDefault();
                                                        }
                                                    }}                                                    disabled
                                                    onChange={event => {
                                                        const { value } = event.target

                                                        if (!value) {
                                                            document.getElementById('seller_fee_basis_points').classList.add('input-error')
                                                        } else {
                                                            document.getElementById('seller_fee_basis_points').classList.remove('input-error')
                                                        }
                                                        setSellerFeesBasisPoints(event.target.value)
                                                    }}
                                                />
                                            </FormGroup>
                                        </Col>

                                    </Row>

                                    <Row>
                                        <Col sm={12}>
                                            <FormGroup>
                                                <Label className='input-label_monserrat'>
                                                    {props.t(`creators %`)}
                                                </Label>
                                                <p className='title-mini'>
                                                    Payments will be split between the wallet address you list here, according to their share.
                                                </p>

                                                {
                                                    creator_array.map((item, i) => {
                                                        return (
                                                            <div className='input-container' key={'cont' + i} >
                                                                <div className='input-container_lg'>
                                                                    <Input
                                                                        required
                                                                        value={item.address}
                                                                        type="text"
                                                                        className="input-white-input circle"
                                                                        placeholder=''
                                                                        disabled
                                                                        id={"creator_address" + i}
                                                                        onChange={handleChangeCreatorAddress}
                                                                    />
                                                                </div>

                                                                <div className='input-container_sm'>
                                                                    {/* <InputGroup>
                                                                        <Input
                                                                            required
                                                                            value={item.share}
                                                                            type="text"
                                                                            className="input-white-input circle"
                                                                            placeholder=''
                                                                            disabled
                                                                            id={"creator_share" + i}
                                                                            onChange={handleChangeCreatorShare}
                                                                        />
                                                                        <InputGroupAddon addonType="append">%</InputGroupAddon>
                                                                    </InputGroup> */}
                                                                    <Input
                                                                        required
                                                                        value={item.share}
                                                                        type="text"
                                                                        className="input-white-input circle"
                                                                        placeholder=''
                                                                        disabled
                                                                        id={"creator_share" + i}
                                                                        onChange={handleChangeCreatorShare}
                                                                    />
                                                                </div>
                                                                {/* <div className='input-container_icon' onClick={() => { removeCreatorInput(i) }}>
                                                            <FontAwesomeIcon icon={faTrashAlt}></FontAwesomeIcon>
                                                        </div> */}
                                                            </div>
                                                        )

                                                    })
                                                }
                                            </FormGroup>
                                        </Col>

                                    </Row>


                                    {/* <Row>
                                <Col sm={6}>
                                    <Button
                                        type="button"
                                        color="primary"
                                        className="btn button_white button_white waves-effect waves-light mb-2 mr-2 uppercase"
                                        onClick={addCreator}
                                    >
                                        {props.t(`Add creator`)}
                                    </Button>
                                </Col>

                            </Row> */}
                                </div>
                            </div>

                        </section>
                        <section className='container-settings-tab-side'>
                            <section className={cn('container-settings-tab-example preview')} style={{ height: '55rem' }}>
                                <p>Token MetaData</p>
                                {/* <div className='collections-settings-row'>
                                    <div className='collections-settings-item'>
                                        <div className='collections-settings-image'>
                                            <img style={{ width: '100%' }} alt="item" src={backgroundImage} />
                                        </div>
                                    </div>
                                </div> */}
                                <div className='container-settings-tab-example-custom'>
                                    <div className='container-settings-tab-example-titles'>
                                        <span className='container-settings-tab-example-titles token-name'>
                                            Token Name
                                        </span>
                                        <span className='container-settings-tab-example-titles token-media'>
                                            Token Media
                                        </span>
                                        <span className='container-settings-tab-example-titles token-description'>
                                            Token <br /> Description
                                        </span>
                                        <span className='container-settings-tab-example-titles external-url'>
                                            External URL
                                        </span>
                                        <div className='container-settings-tab-example-stroke stoken-name'>
                                        </div>
                                        <div className='container-settings-tab-example-stroke stoken-media'>
                                        </div>
                                        <div className='container-settings-tab-example-stroke stoken-description'>
                                        </div>
                                        <div className='container-settings-tab-example-stroke sexternal-url'>
                                        </div>
                                    </div>
                                    <div className='container-settings-tab-example-card'>
                                        <div className='container-settings-tab-example-card-title'>
                                            <FontAwesomeIcon icon={faArrowLeft}></FontAwesomeIcon>
                                            <span> {collectionName}</span>
                                            <FontAwesomeIcon icon={faEllipsisVertical}></FontAwesomeIcon>
                                        </div>
                                        <div className='container-settings-tab-example-card-img'>
                                            <img src={image_id} />
                                        </div>
                                        <div className='container-settings-tab-example-card-buttons'>
                                            <div className='container-settings-tab-example-card-buttons-card'>
                                                Send
                                            </div>
                                            <div className='container-settings-tab-example-card-buttons-card'>
                                                List
                                            </div>
                                        </div>
                                        <div className='container-settings-tab-example-card-description'>
                                            <span className='container-settings-tab-example-card-description-title'>
                                                Description
                                            </span>
                                            <span>
                                                {tokenDescription}
                                            </span>
                                            <span className='container-settings-tab-example-card-description-url'>
                                                {tokenExternal}
                                            </span>
                                        </div>
                                        <div className='container-settings-tab-example-card-bottom'>
                                            <img src={bottomButton} />
                                        </div>
                                    </div>

                                </div>
                            </section>
                            <section className='container-settings-tab-example table'>
                                <span className='container-settings-tab-example-table-title'>Future Earnings</span>
                                <table>
                                    <thead>
                                        <tr>
                                            <th>Contract</th>
                                            <th>Token</th>
                                            <th>Estimated Value</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>{collectionName}</td>
                                            <td>{tokens}</td>
                                            <td>{naiveRound((price * tokens))} {selectedBlockChain.name}</td>
                                        </tr>
                                    </tbody>
                                </table>
                                <table>
                                    <thead>
                                        <tr>
                                            <th>Revenue percentage</th>
                                            <th>Royalties</th>
                                            <th>Estimated earning per re-sale</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {creator_array.length > 0 && (
                                            creator_array.map((item, i) => {
                                                return (
                                                    <tr key={i}>
                                                        <td>{item.address.length <= 5 ? item.address : '...' + item.address.substring(item.address.length - 6, item.address.length)}</td>
                                                        <td>{item.share * (seller_fee_basis_points || 0)}</td>
                                                        <td>{naiveRound((((price * tokens) / 100) * item.share))} {selectedBlockChain.name}</td>
                                                    </tr>
                                                )
                                            })
                                        )}
                                        {creator_array.length === 0 && (
                                            <tr>
                                                <td>No revenue</td>
                                                <td>No Royalties</td>
                                                <td>No earning</td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </section>
                        </section>
                        <Row>
                            <Col sm={12}>
                                <Button
                                    type="button"
                                    color="secundary"
                                    className="theme-button-secundary mobile"
                                    disabled={inputLoader}
                                    onClick={(e) => {
                                        e.preventDefault()
                                        segmentTrack(`update project`)
                                        _handleSubmit()
                                    }}
                                >
                                    {props.t(`Update minting`)}
                                </Button>
                            </Col>
                        </Row>
                    </section>
                </div>
                <div className='bottom_clear'></div>

            </Form>
        </React.Fragment >
    )
}

export default withRouter(withNamespaces()(Settings))